var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapFullScreen",staticClass:"map-control map-full-screen",style:({ top: _vm.top, bottom: _vm.bottom, left: _vm.left, right: _vm.right })})
}
var staticRenderFns = []

export { render, staticRenderFns }